import React, { useState, useRef } from 'react';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Modal } from 'antd';
import {insertParameter, getParameter, updateParameter} from '../../../../../apis/FuncionApi';
import {variable_formula} from '@app/constants/variablesFormula';
import moment from 'moment';
import './styles.scss';
const { Option } = Select;
const App = ({title, funcionId, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const handleOk = async () => {

        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {
            funcion_id: funcionId
        }
        if(ID > 0){
            const payload = {
                id: ID,
                ...defaultValue,
                ...fields
            }
            const response = await updateParameter(payload);
            if(response.ok){
                message.success('Se guardo correctamente el parametro!');
                setShowModal(false);
                finish(true);
            }
        }else{
            const payload = {
                funcion_id: funcionId,
                ...fields
            }
            const response = await insertParameter(payload);
            if(response.ok){
                message.success('Se guardo correctamente el parametro!');
                setShowModal(false);
                finish(true);
            }
        }
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
    }, [id]);


    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async ()=>{
            if(ID > 0){
                await refreshData();
            }else{
                setInitialValues({
                    nombre: null,
                    descripcion: null,
                    tipo_dato: null,
                    activo: true
                });
            }
        })()
      }
    
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        if(ID > 0){
            const response = await getParameter(ID);
            if(response.ok){
              let item = response.payload;
              setInitialValues(item);
            }
        }else{
            setInitialValues({
                nombre: null,
                descripcion: null,
                tipo_dato: null,
                activo: true
            });
        }
    }

  return (
      <Drawer
        title={title}
        width={720}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'80%'}
        onFinish={handleOk}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark onFinish={handleOk} initialValues={initialValues}>
                <Row gutter={16}>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="nombre"
                            label="Nombre"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega un nombre',
                            },
                            ]}
                        >
                            <Input placeholder="Por favor agrega un nombre" />
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="descripcion"
                            label="Descripción"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega una descripción',
                            },
                            ]}
                        >
                            <Input placeholder="Por favor agrega una descripción" />
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="tipo_dato"
                            label="Tipo de Dato"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor selecciona un tipo de dato',
                            },
                            ]}
                        >
                            <Select placeholder="Por favor selecciona un tipo de dato">
                                {
                                    variable_formula.list.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        }
      </Drawer>
  );
};
export default App;